import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import RadioMUI, { RadioProps } from '@mui/material/Radio';

const RadioButton: React.FC<RadioProps> = ({ className, ...restProps }) => {
	const { RadioButton: css } = useTheme('BaseComponents');

	return (
		<RadioMUI
			className={cn(css.radioButton, className)}
			classes={{
				checked: css.checked,
				disabled: css.disabled
			}}
			{...restProps}
		/>
	);
};

export default RadioButton;
